export type Risk = 'LOW' | 'MEDIUM' | 'HIGH';

export const isRisk = (x: any): x is Risk =>
  x === 'LOW' || x === 'MEDIUM' || x === 'HIGH';

export type ExtendedRisk = Risk | 'VERY_HIGH';

export const isExtendedRisk = (x: any): x is ExtendedRisk =>
  isRisk(x) || x === 'VERY_HIGH';
